<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!--  Begin: List Card -->

        <!-- Begin: Page Option -->
        <div class="row">
          <div class="col-sm-12 text-right">
            <right-panel
              class="float-right"
              id="sidebar-process-datasource-datasubject-tranfering-legal-pair"
              width="800px"
              :icon="'mdi mdi-plus'"
              :text="$t('common.add')"
              @hidden="rightPanelClosed"
            >
              <div class="pl-5 pr-5">
                <Form :state="state" :hide-library="true" @onSave="multipleSave" />
              </div>
            </right-panel>
          </div>
        </div>
        <!-- End: Page Option -->

        <!-- Begin: Table -->

        <div class="bg-white">
          <table class="table table-bordered table-striped">
            <thead class="bg-secondary text-white">
              <tr>
                <th style="width: 100px">
                  <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                    <template #button-content>
                      <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                    </template>
                    <b-dropdown-item href="#" @click="multipleDeleteById(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                      <i class="bx bx-trash-alt text-danger" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete") }} ({{ selectedItems.length }})
                    </b-dropdown-item>
                  </b-dropdown>
                </th>
                <th>Ürün</th>
                <th>Alıcı Grubu</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("datasource.text") }}</th>
                <th>İlgili Kişi</th>
                <th>İşleme/Aktarım Amacı</th>
                <th>Hukuki Sebebi</th>
                <th>{{ $t("common.type") }}</th>
                <th scope="col" style="width: 15%">
                  <a href="javascript:;" @click="toggleFilter">
                    <span v-if="filterEnabled" class="text-warning">
                      <i class="bx bxs-filter-alt"></i>
                      {{ $t("common.filters-hide") }}
                    </span>
                    <span v-else class="text-white">
                      <i class="bx bxs-filter-alt"></i>
                      {{ $t("common.filters-show") }}
                    </span>
                  </a>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="filterEnabled">
                <th></th>
                <th></th>
                <th></th>
                <th>
                  <filter-select id="processFilter" ref="processFilter" :placeholder="$t('process.text')" :multiple="false" @filter="onProcessSearch" @changed="onProcessSelect" />
                </th>
                <th>
                  <filter-select
                    id="datasourceFilter"
                    ref="datasourceFilter"
                    :placeholder="$t('datasource.text')"
                    :multiple="false"
                    @filter="onDatasourceSearch"
                    @changed="onDatasourceSelect"
                  />
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <template v-if="pagination">
                <tr v-for="item in pagination.docs" :key="item._id">
                  <td>
                    <div class="text-center">
                      <b-form-checkbox v-if="isCompatibleWithScope(item)" v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                    </div>
                  </td>
                  <td>
                    {{ item.products.join(", ") }}
                  </td>
                  <td>
                    {{ item.receiverGroup.name | translate }}
                  </td>

                  <td>
                    <span v-if="item.process">
                      {{ item.process.name | translate }}
                    </span>
                  </td>
                  <td>
                    <span v-if="item.datasource">{{ item.datasource.name | translate }}</span>
                  </td>
                  <td>
                    {{ item.datasubject.name | translate }}
                  </td>
                  <td>
                    <ol>
                      <li v-for="purpose in item.purposes" :key="purpose._id">{{ purpose.name | translate }}</li>
                    </ol>
                  </td>
                  <td>
                    <ol>
                      <li v-for="legalReason in item.legalReasons" :key="legalReason._id">{{ legalReason.name | translate }}</li>
                    </ol>
                  </td>
                  <td>
                    <span v-if="item.scope && isWorkspaceScopedItem(item)">{{ item.scope.value }}</span>
                    <span v-else>{{ $t("common.system") }}</span>
                  </td>
                  <td>
                    <div v-if="isCompatibleWithScope(item)" class="font-size-16 text-center">
                      <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                      <i class="bx bx-trash text-danger hand ml-2" v-b-tooltip.hover :title="$t('common.delete')" @click="remove(item)"></i>
                    </div>
                  </td></tr
              ></template>
            </tbody>
          </table>
          <content-loading class="text-center" v-if="isLoading" />
        </div>
        <!-- End: Table -->

        <!-- Begin: Pagination -->
        <div v-if="pagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->

        <b-modal id="modal-multiple-delete-operation-process-datasource-storage-period" centered :title="$t('common.multiple-delete-operation')" hide-footer>
          <div v-if="deleteOperationResult">
            <div v-if="deleteOperationResult.success.length > 0">
              <h5 class="text-success">{{ $t("common.delete-items") }}</h5>
              <ul>
                <li v-for="item in deleteOperationResult.success" :key="item._id">
                  {{ item | translate }}
                </li>
              </ul>
            </div>

            <div v-if="deleteOperationResult.failed.length > 0">
              <h5 class="text-danger mt-4">{{ $t("common.delete-failed") }}</h5>
              <ul>
                <li v-for="item in deleteOperationResult.failed" :key="item._id">
                  <b> {{ item.name | translate }}</b>
                  {{ item.error }}
                </li>
              </ul>
            </div>
          </div>
        </b-modal>

        <b-modal id="modal-multiple-save-process-datasource-datasubject-tranfering-legal" centered :title="$t('common.multiple-add-operation')" hide-footer>
          <div v-if="Object.keys(success).length > 0">
            <h5 class="text-success mt-4">{{ $t("common.added") }}</h5>
            <ul>
              <li v-for="key in Object.keys(success)" :key="key">
                <b v-if="success[key][0].process"> {{ success[key][0].process.name | translate }}</b>
                <ol>
                  <li v-for="i in success[key]" :key="i">
                    <span v-if="i.datasubject">
                      {{ i.datasubject.name | translate }}
                    </span>
                  </li>
                </ol>
              </li>
            </ul>
          </div>

          <div v-if="Object.keys(fail).length > 0">
            <h5 class="text-danger mt-4">{{ $t("common.not-added") }}</h5>
            <ul>
              <li v-for="key in Object.keys(fail)" :key="key">
                <b v-if="fail[key][0].process"> {{ fail[key][0].process.name | translate }}</b>
                <ol>
                  <li v-for="i in fail[key]" :key="i">
                    <span v-if="i.datasubject">
                      {{ i.datasubject.name | translate }}
                    </span>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import FilterSelect from "@c/form/filter-select";
import RightPanel from "@c/right-panel";
import { required } from "vuelidate/lib/validators";
import Form from "./process-datasource-datasubject-transfering-legal-form";

const state = "processDatasourceDatasubjectTransferingLegal";
export default {
  components: {
    RightPanel,
    FilterSelect,
    Form,
  },
  props: ["state"],
  data() {
    return {
      form: { datasource: undefined },
      request: {
        options: {
          page: 1,
          limit: 15,
          sort: { ...(this.state === "workspaceProcessDatasourceDatasubjectTransferingLegal" ? { "scope.workspace": "desc" } : { "scope.workspace": "asc" }) },
        },
        query: {},
      },
      filterEnabled: false,
      selectedItems: [],
      success: {},
      fail: {},
    };
  },
  validations: {
    form: {
      datasource: {
        required,
      },
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.init());
      },
    },
  },
  mounted() {
    this.state = this.state || state;
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceProcessDatasourceDatasubjectTransferingLegal";
    },
    pagination() {
      return this.$store.getters[`${this.state}/pagination`];
    },
    isLoading() {
      return this.$store.getters[`${this.state}/isLoading`];
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
    deleteOperationResult() {
      return this.$store.getters[`${this.state}/deleteOperationResult`];
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
  },

  methods: {
    isCompatibleWithScope(item) {
      return (this.isWorkspaceLayout && this.isWorkspaceScopedItem(item)) || (!this.isWorkspaceLayout && !this.isWorkspaceScopedItem(item));
    },
    isWorkspaceScopedItem(item) {
      return item.scope?.value == "workspace";
    },
    init() {
      this.$store.dispatch(`${this.state}/paginate`, this.request);
    },
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.pagination.docs.slice();
        if (this.state === "workspaceProcessDatasourceDatasubjectTransferingLegal") {
          this.selectedItems = this.selectedItems.filter((i) => i.scope?.value == "workspace");
        }
      }
    },

    async onProcessSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceProcess" : "managementProcess";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onProcessSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          process: item._id,
        };
      } else {
        this.request.query["process"] = null;
        delete this.request.query["process"];
      }
    },
    async onDatasourceSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDatasource" : "managementDatasource";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDatasourceSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          datasource: item._id,
        };
      } else {
        this.request.query["datasource"] = null;
        delete this.request.query["datasource"];
      }
    },
    rightPanelClosed() {
      this.$store.commit(`${this.state}/editedEntity`, null);
      this.init();
    },
    edit(item) {
      this.$store.commit(`${this.state}/editedEntity`, { ...item });
      this.$root.$emit("bv::toggle::collapse", "sidebar-process-datasource-datasubject-tranfering-legal-pair");
    },
    async multipleDeleteById(selectedItems) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${this.state}/multipleDelete`, selectedItems);
        this.init();
        this.selectedItems = [];
        this.$root.$emit("bv::toggle::modal", "modal-multiple-delete-operation-process-datasource-storage-period");
      } catch (error) {
        console.error(error);
      }
    },
    async remove(record) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${this.state}/delete`, record._id);

        this.init();

        this.$toast.success("'" + this.$options.filters.translate(record.process.name) + "-" + this.$options.filters.translate(record.datasource.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, {
          customMessage: "'" + this.$options.filters.translate(record.process.name) + "-" + this.$options.filters.translate(record.datasource.name) + "' Silinemedi",
        });
      }
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    datasourceSelect(item) {
      this.form = { ...this.form, datasource: item };
    },
    async multipleSave(entityId, products, receiverGroups, processes, childDatasources, datasubjects, purposes, legalReasons) {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }

      this.fail = {};
      this.success = {};

      if (!processes || processes.length == 0) {
        processes = [null];
      } else {
        processes = Array.isArray(processes) ? processes : [processes];
      }

      if (!childDatasources || childDatasources.length == 0) {
        childDatasources = [null];
      } else {
        childDatasources = Array.isArray(childDatasources) ? childDatasources : [childDatasources];
      }

      try {
        for (const receiverGroup of receiverGroups) {
          for (const process of processes) {
            for (const datasource of childDatasources) {
              for (const datasubject of datasubjects) {
                try {
                  if (entityId) {
                    await this.$store.dispatch(`${this.state}/update`, { _id: entityId, receiverGroup, products, process, datasource, datasubject, purposes, legalReasons });
                  } else {
                    await this.$store.dispatch(`${this.state}/save`, { products, receiverGroup, process, datasource, datasubject, purposes, legalReasons });
                  }

                  if (this.success[process._id]) {
                    this.success[process._id].push({ process, datasource, datasubject, purposes, legalReasons });
                  } else {
                    this.success[process._id] = [{ process, datasource, datasubject, purposes, legalReasons }];
                  }
                } catch (error) {
                  if (this.fail[process._id]) {
                    this.fail[process._id].push({ process, datasource, datasubject, purposes, legalReasons });
                  } else {
                    this.fail[process._id] = [{ process, datasource, datasubject, purposes, legalReasons }];
                  }
                }
              }
            }
          }
        }
      } catch (e) {
        console.error(e);
      }

      this.selectedItems = [];

      this.$root.$emit("bv::toggle::modal", "modal-multiple-save-process-datasource-datasubject-tranfering-legal");
      if (this.$refs.datasourceFilter) {
        this.$refs.datasourceFilter.reset();
      }

      this.$root.$emit("bv::toggle::collapse", "sidebar-process-datasource-datasubject-tranfering-legal-pair");

      this.rightPanelClosed();
    },
  },
};
</script>
